export const Tiers = {
  FREE: 'FREE',
  TRIAL: 'TRIAL',
  PAID: 'PAID',
  STARTER: 'STARTER',
  BASE: 'BASE',
  ADVANCED: 'ADVANCED',
};

export const FreeTiers = [Tiers.FREE, Tiers.TRIAL];
export const PaidTiers = [Tiers.STARTER, Tiers.BASE, Tiers.ADVANCED];

export const getTier = tier => Tiers[tier.toUpperCase()];
export const isFreePlan = tier => FreeTiers.includes(tier?.toUpperCase());
export const isPaidPlan = tier => PaidTiers.includes(tier?.toUpperCase());
